export default function Beauty24() {
  return <div className="img-wrapper beauty"></div>;
}
